import Utils__ReactLoaderController from '../react_loader_controller'
import { Application } from '@hotwired/stimulus'

import { i18nextPromise } from '../config/i18next.js'

export const applicationPromise = i18nextPromise.then(() => {
  const application = Application.start()
  application.register("utils--react-loader", Utils__ReactLoaderController)
  return application
})
